import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import BusinessIcon from '@mui/icons-material/Business';
import CategoryIcon from '@mui/icons-material/Category';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import BusinessEditRequest from "./components/businessEditRequest/businessEditRequest";
import ServiceEditRequest from "./components/serviceEditRequest/serviceEditRequest";
import CategoryEditRequest from "./components/categoryEditRequest/categoryEditRequest";
import { styled } from "@mui/material/styles";


const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
};

const EditRequest = () => {



  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const StyledTab = styled(Tab)({
    "&.Mui-selected": {
      color: "#ff4d4d",
    
    }
  });


  
  return (
    <>
    
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="icon label tabs example"
        TabIndicatorProps={{
          style: {
            backgroundColor: "#ff4d4d"
          }
        }}
      >
        <StyledTab  sx={{ textTransform: "none" }} icon={<CategoryIcon />} iconPosition="start" label="Category Edit Requests" />
        <StyledTab  sx={{ textTransform: "none" }} icon={<FormatListBulletedIcon />} iconPosition="start" label="Service Edit Requests" />
        <StyledTab  sx={{ textTransform: "none" }} icon={<BusinessIcon />} iconPosition="start" label="Business Edit Requests" />
        
      </Tabs>
      <TabPanel value={value} index={0}>
      <CategoryEditRequest/>
      </TabPanel>
      <TabPanel value={value} index={1}>
       <ServiceEditRequest/>
      </TabPanel>
      <TabPanel value={value} index={2}>
      <BusinessEditRequest />
      </TabPanel>
      </>
     
  )
}

export default EditRequest